import {
  Invoice,
  InvoicePayment,
  InvoicePaymentMethod,
  InvoicePaymentStatus,
  InvoiceStatus
} from "@wingspanhq/wingspan-api-sdk";

const UNPAID_PAYMENT_STATUSES: InvoicePaymentStatus[] = [
  InvoicePaymentStatus.FAILED,
  InvoicePaymentStatus.CANCELLED,
  InvoicePaymentStatus.RETURNED
];

const isStandingPayment = (payment: InvoicePayment) =>
  !UNPAID_PAYMENT_STATUSES.includes(payment.status);

// Deliberately not `amountDetails` or `estimatedDepositAt`: on v3 those are
// reconciliation/payout projections that are absent whenever reconciliation has
// not run, whatever the payment method was (WIN-15936).
export const selectorIsInvoicePaidOffPlatform = (invoice: Invoice): boolean => {
  const standingPayments = (invoice.payments ?? []).filter(isStandingPayment);

  if (standingPayments.length > 0) {
    return standingPayments.every(
      payment => payment.method === InvoicePaymentMethod.OFF_PLATFORM
    );
  }

  return (
    invoice.status === InvoiceStatus.PAID_OFF_PLATFORM ||
    !!invoice.events?.paidOffPlatformAt ||
    !!invoice.events?.markedPaidAt
  );
};
